import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

interface TabBarVisibilityValue {
  hideTabBar: boolean;
  setHideTabBar: (hide: boolean) => void;
}

const TabBarVisibilityContext = createContext<TabBarVisibilityValue | null>(null);

export const TabBarVisibilityProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [hideTabBar, setHideTabBarState] = useState(false);
  const setHideTabBar = useCallback((hide: boolean) => {
    setHideTabBarState(hide);
  }, []);
  const value = useMemo(
    () => ({ hideTabBar, setHideTabBar }),
    [hideTabBar, setHideTabBar]
  );
  return <TabBarVisibilityContext.Provider value={value}>{children}</TabBarVisibilityContext.Provider>;
};

/**
 * When `hideTabBar` is true, `MainLayout` should not render the bottom tab bar
 * (e.g. profile “settings” sub-screens that are full-width edits).
 */
export const useTabBarVisibility = (): TabBarVisibilityValue => {
  const ctx = useContext(TabBarVisibilityContext);
  if (!ctx) {
    return { hideTabBar: false, setHideTabBar: () => {} };
  }
  return ctx;
};
